import { Empty } from "../@client/Theasoft_ApiServer__Utils_TreeBase"
import { TreePillsInput, TreePillsInputProps } from "./tree/tree-pills-input"
import { useSuspenseQueryGet } from "../typed-client/hooks/use-suspense-query-get"
import { useTranslation } from "react-i18next"

interface DepartmentOrWorkareaTreeSelectProps
  extends Omit<TreePillsInputProps<Empty>, "tree"> {}

export function DepartmentOrWorkareaTreeSelect(
  props: DepartmentOrWorkareaTreeSelectProps
) {
  const { data } = useSuspenseQueryGet("/api/WorkArea/GetWorkAreaTree", null)
  const { t } = useTranslation("app_server")
  return <TreePillsInput label={t("Departments")} {...data} {...props} />
}
